import {useQuery} from '@tanstack/react-query'
import axios from 'axios'
import {useAppOrigin} from '~/app/hooks/use-app-origin'
import {isProduction} from '@/utils/common'

const fetchCustomSitePreferences = async (appOrigin, params = {}) => {
    try {
        const response = await axios.get(`${appOrigin}/api/site-preferences`, {
            params
        })
        return response.data
    } catch (error) {
        throw new Error('Failed to fetch site preferences', error)
    }
}

export const useGetCustomSitePreferences = ({params = {}, enabled = true} = {}) => {
    const appOrigin = useAppOrigin()
    const {data, error, refetch} = useQuery({
        queryKey: ['customSitePreferences', params],
        queryFn: () => fetchCustomSitePreferences(appOrigin, params),
        staleTime: isProduction ? 1000 * 60 * 5 : 0, // 5 minutes
        enabled
    })

    return {
        customSitePreferences: data,
        customSitePreferencesError: error,
        refreshCustomSitePreferences: refetch
    }
}
